import styled from 'styled-components';

export const SpanButton = styled.span(
  ({ underline, theme, active, shouldHighLight }) => `
  cursor: pointer;
  display: inline-block;
  text-decoration : ${underline ? 'underline' : 'none'};
  font-family: ${theme.fonts.secondaryFontFamily};
  font-size: 16px;
  ${underline ? `color: ${theme.colorPalette.primary.main}` : ''};
  ${active || shouldHighLight ? 'font-weight: 800' : 'font-weight: normal'}
`
);

export const Underline = styled.u(
  ({ theme }) => `
  display:block;
  height:2px;
  margin-top:4px;
  background-color: ${theme.colors.PLP_SIDE_NAVBAR_SUBHEADER_BORDER};
  &:focus{
    outline:none;
  }
`
);
